import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import * as enableActions from '../../actions/enable-consent.actions';
import { BsModalRef } from 'ngx-bootstrap';
import { ContainerComponent } from '../../../shared/components/container-component/unsubscribe.component';
import { selectLang } from '../../../url-params/url-params.selector';
import { AuthorizationResponse } from '../../../../core/model/authorization/authorization-response.model';
import { AuthorizationSecurityError } from '../../../../core/model/authorization/authorization-security-error.enum';
import { ConsentState } from '../../consent.state';
import { EnableConsent } from '../../model/enable-consent.model';
import { selectEnableConsentAuth, selectEnableConsentAuthAuthorization } from '../../consent.selector';

@Component({
    selector: 'ssf-enable-consent-auth-dialog',
    template: `
        <ssf-authorization-dialog
            [signInfo]="(authorization$ | async)"
            [lang]="(lang$| async)"
            (onMessage)="onMessage($event)"
            (onAuthorizationSecurityError)="onAuthorizationSecurityError($event)"
            (onHide)="onHide()">
        </ssf-authorization-dialog>
    `
})
export class EnableConsentAuthDialogComponent extends ContainerComponent {
    public authorization$: Observable<EnableConsent>;
    public lang$: Observable<string>;

    constructor(private store: Store<ConsentState>, public bsModalRef: BsModalRef) {
        super();

        this.authorization$ = this.store.select(selectEnableConsentAuthAuthorization);

        // modal is hidden when state.enableConsentAuth.shown === null; see reducer
        this.store.select(selectEnableConsentAuth)
            .takeUntil(this.ngUnsubscribe)
            .filter((value) => !value.shown)
            .subscribe(() => bsModalRef.hide());

        this.lang$ = this.store.select(selectLang);
    }

    onMessage(event: AuthorizationResponse) {
        this.store.dispatch(new enableActions.EnableConsentAuthFinishedAction(event));
    }

    onAuthorizationSecurityError(error: AuthorizationSecurityError) {
        this.store.dispatch(new enableActions.EnableConsentAuthErrorAction(error));
    }

    onHide() {
        this.store.dispatch(new enableActions.EnableConsentCancelAction());
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/consent/components/enable-consent-auth-dialog/enable-consent-auth-dialog.component.ts